import React from 'react'

import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { SlackNotificationsForm } from '@/views/Organizations/components/SlackNotificationsForm'
import { SLACK_NOTIFICATIONS_MODAL_ID } from '@/views/Organizations/components/buttons/manageSlackNotifications.constants'

/**
 * Self-serve Slack setup entry for org admins (edit_users), shown on /users.
 * Opens a modal that connects the org's Slack workspace via OAuth, or shows
 * its status with Change workspace + Disconnect. The Balto-admin multi-provider
 * IntegrationCredentialForm modal is separate and stays Balto-only.
 */
export const ManageSlackNotificationsButton = ({ organizationId }) => {
  return (
    <ButtonAndFormModal
      buttonLabel="Manage Slack Notifications"
      modalTitle="Manage Slack Notifications"
      modalId={SLACK_NOTIFICATIONS_MODAL_ID}
      modalProps={{ size: 'small' }}
      buttonProps={{ primary: true }}
      form={<SlackNotificationsForm organizationId={organizationId} />}
    />
  )
}
